export default __webpack_public_path__ + "static/media/reward-tiers1.6c821352.webp";